import { useCallback } from 'react';

import { Checkbox } from '../../../../../../../../../helpers/Checkbox';

interface ThreeDStockProductsFiltersSeasonalFilterItemTag {
  id: string;
  label: string;
}

interface ThreeDStockProductsFiltersSeasonalFilterItemProps {
  tag: ThreeDStockProductsFiltersSeasonalFilterItemTag;
  onCheckedTag: (tagId: string, checked: boolean) => void;
  checked: boolean;
}

function ThreeDStockProductsFiltersSeasonalFilterItem({
  onCheckedTag,
  tag,
  checked
}: ThreeDStockProductsFiltersSeasonalFilterItemProps) {
  const handleCheck = useCallback(
    (checked: boolean) => {
      onCheckedTag(tag.id, checked);
    },
    [onCheckedTag, tag]
  );

  return (
    <li className="py-1">
      <Checkbox
        dataGa={`seasonal-${tag.label}`}
        checkboxWrapperClassName="flex items-center"
        label={tag.label}
        checked={checked}
        onChange={handleCheck}
      />
    </li>
  );
}

export default ThreeDStockProductsFiltersSeasonalFilterItem;
